import { render, staticRenderFns } from "./pro_desc.vue?vue&type=template&id=ac8c4cd0&scoped=true"
import script from "./pro_desc.vue?vue&type=script&lang=js"
export * from "./pro_desc.vue?vue&type=script&lang=js"
import style0 from "./pro_desc.vue?vue&type=style&index=0&id=ac8c4cd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c4cd0",
  null
  
)

export default component.exports